import remember from './remember';
import fetchJsonFromRpgLogsApi from './fetchJsonFromRpgLogsApi';
import GoogleAnalyticsViewModel from '../../resources/js/typings/viewModels/googleAnalyticsViewModel';
import { ArchonHeaderViewModel } from '../components/ArchonHeader/ArchonHeader';
import { ArchonFooterViewModel } from '../components/ArchonFooter/ArchonFooter';
import { AdPlacementsViewModel } from '@resources/js/typings/viewModels/adPlacements';
import { PlaywireAdsViewModel } from '@resources/js/contexts/usePlaywire';

export type CommonViewModels = {
  googleAnalytics: GoogleAnalyticsViewModel;
  adPlacements: AdPlacementsViewModel;
  playwireAds: PlaywireAdsViewModel;
  header: ArchonHeaderViewModel;
  footer: ArchonFooterViewModel;
};

export default function getCommonViewModels(
  gameSlug: string | null = null
): Promise<CommonViewModels> {
  return remember(`getCommonViewModels-${gameSlug}-v10`, 600, async () => {
    const data = await fetchJsonFromRpgLogsApi(
      `query($gameSlug: String) {
      viewModels {
        googleAnalytics
        adPlacements
        playwireAds
        header(gameSlug: $gameSlug)
        footer
      }
    }`,
      {
        gameSlug,
      },
      gameSlug
    );

    return data.viewModels;
  });
}
